<template>
    <div class="block b-left blok-3">
        <div class="tab mbo-3">
            <div
                class="tab-item"
                :class="{ active: tab === 'DEPOSIT' }"
                @click="setTab('DEPOSIT')"
            >
                Deposit
            </div>
            <div
                class="tab-item"
                :class="{ active: tab === 'WITHDRAW' }"
                @click="setTab('WITHDRAW')"
            >
                Withdraw
            </div>
            <div
                v-if="vault.can_wrap"
                class="tab-item"
                :class="{ active: tab === 'WRAP' }"
                @click="setTab('WRAP')"
            >
                Wrap
            </div>
        </div>
        <ILDeposit v-show="tab === 'DEPOSIT'" class="mob-space" key="deposit" />
        <ILWithdraw
            v-show="tab === 'WITHDRAW'"
            class="mob-space"
            key="withdraw"
        />
        <VaultWrap
            v-show="tab === 'WRAP'"
            class="mob-space"
            :vault="vault"
            key="wrap"
        />
    </div>
</template>

<script>
import ILDeposit from "./ILDeposit";
import ILWithdraw from "./ILWithdraw";
import VaultWrap from "./../VaultWrap";
import { mapState, mapActions } from "vuex";
export default {
    components: {
        ILDeposit,
        ILWithdraw,
        VaultWrap
    },
    data() {
        return {
            // tab: "DEPOSIT"
        };
    },
    computed: {
        ...mapState("il", ["tab", "vault"])
    },
    methods: {
        ...mapActions("il", ["setTab"])
    }
};
</script>
